export default __webpack_public_path__ + "static/media/arrow-left.90c40332.svg";